// This file was auto-generated by @revolt/openapi-generator!
export const defaultBaseURL = "https://api.revolt.chat";